<template>
  <div class="payment-options">
    <h2 class="d-flex flex-row justify-content-between align-items-center">
      <div>{{ $t("payment.choose-wallet") }}</div>
    </h2>
    <div class="payment-option-inner" v-if="selectedTabIndex > -1">
      <b-tabs small justified active-nav-item-class="active-tab" active-tab-class="active-tab_content"
        @activate-tab="activateTab" v-model="selectedTabIndex">
        <!--Crypto exchange-->
        <b-tab v-if="filteredTab.includes(cryptoExchangeName)" :title="cryptoExchangeName" :title-link-class="'link-class'" class="tab-item"
          :id="cryptoExchangeName" :disabled="cryptoPaymentStatus == 'partial' ||
            isContinuedTransaction ||
            isInProcess
            " @click="handleChange('Exchange')">
            <transition name="fade">
              <v-slot>
                <template #title>
                  <img v-if="selectedTab === cryptoExchangeName" src="@/assets/img/tabs/exchangeTabWhite.svg" alt="" />
                  <img v-else src="@/assets/img/tabs/exchangeTabBlack.svg" alt="" />
                  <span class="ml-1 mt-1">{{ cryptoExchangeName }}</span>
                </template>
                <div class="tab-data__wrapper">
                  <div class="tab-data__content no-top-border">
                    <div v-if="selectedTab === cryptoExchangeName">
                      <ExchangesV2 :isPreview="isPreview" :displayCurrency="displayCurrency" :convertedCart="convertedCart"
                        :cartData="cartData" @setLoader="setLoader" />
                    </div>
                  </div>
                </div>
              </v-slot>
            </transition>
        </b-tab>
        <!--Crypto Wallet-->
        <b-tab v-if="filteredTab.includes(cryptoWalletName)" :title="cryptoWalletName" :id="cryptoWalletName"
          :title-link-class="'link-class'" class="tab-item" @click="handleChange('Wallet')">
          <transition name="fade">
            <v-slot>
              <!-- <div v-if="selectedTab === cryptoWalletName"> -->
              <template #title>
                <img v-if="selectedTab === cryptoWalletName" src="@/assets/img/tabs/walletTabWhite.svg" alt="" />
                <img v-else src="@/assets/img/tabs/walletTabBlack.svg" alt="" />
                <span class="ml-1 mt-1">{{ cryptoWalletName }}</span>
              </template>
              <div>
                <crypto-wallet v-if="!enableWalletConnect" :isContinuedTransaction="isContinuedTransaction"
                  :isPreview="isPreview" :walletOptions="walletOptions" :selectedTab="selectedTab === cryptoWalletName"
                  @setLoader="setLoader" @paymentConfirmed="isPaymentMethodVisible = false"
                  :navigateToPreviousStep="navigateToPreviousStep" :cartData="cartData"
                  @cryptoPaymentStatus="setCryptoPaymentStatus" @anyWalletCoin="onWalletCoinChange"
                  @changePaymentType="changePaymentType" />
                <wallet-page v-else :isContinuedTransaction="isContinuedTransaction" :isPreview="isPreview"
                  :walletOptions="walletOptions" :selectedTab="selectedTab === cryptoWalletName" @setLoader="setLoader"
                  @paymentConfirmed="isPaymentMethodVisible = false" :navigateToPreviousStep="navigateToPreviousStep"
                  :cartData="cartData" @cryptoPaymentStatus="setCryptoPaymentStatus" @anyWalletCoin="onWalletCoinChange"
                  @setInprocess="setInprocess" />
              </div>
              <!-- </div> -->
            </v-slot>
          </transition>
        </b-tab>
        <!--Bank-->
        <b-tab :disabled="cryptoPaymentStatus == 'partial' ||
          isContinuedTransaction ||
          isInProcess
          " v-if="filteredTab.includes(bankTabName) &&
    settings.displayCurrency &&
    settings.displayCurrency.toLowerCase() === 'usd' &&
    !isGuestUser
    " :title="bankTabName" :title-link-class="'link-class'" :id="bankTabName" class="tab-item" @click="handleChange('Bank')">
          <transition name="fade">
            <v-slot>
              <template #title>
                <img v-if="selectedTab === bankTabName" src="@/assets/img/tabs/bankTabWhite.svg" alt="" />
                <img v-else-if="isSubscriptionTabEnabled" src="@/assets/img/tabs/bankTabGrey.svg" alt="" />
                <img v-else src="@/assets/img/tabs/bankTabBlack.svg" alt="" />
                <span class="ml-1 mt-1">{{ bankTabName }}</span>
              </template>
              <Bank @setLoader="setLoader" :rootConvertedData="convertedCart" />  
            </v-slot>
          </transition>          
        </b-tab>
        <b-tab v-if="filteredTab.includes(buyTab) && !isGuestUser" :title="buyTab" :title-link-class="'link-class'" :id="buyTab"
          class="tab-item" @click="handleChange('Onramp')" :disabled="cryptoPaymentStatus == 'partial' ||
            isContinuedTransaction ||
            isInProcess
            ">
            <transition name="fade">
              <v-slot>
                <template #title>
                  <img v-if="selectedTab === buyTab" src="@/assets/img/tabs/coins-white.svg" alt="" class="logo-i" />
                  <img v-else src="@/assets/img/tabs/coins.svg" alt="" class="logo-i" />
                  <span class="ml-1 mt-1">{{ buyTab }}</span>
                </template>
                <sardine @setLoader="setLoader" />
              </v-slot>              
            </transition>          
        </b-tab>
      </b-tabs>
    </div>
  </div>
</template>
<script>
/* eslint-disable global-require */

import { BTabs, BTab } from "bootstrap-vue";
import { mapGetters } from "vuex";
import ExchangesV2 from "@/components/ExchangesV2.vue";
import Bank from "@/components/Bank.vue";
import { SET_TAB, USER_TRACK_EVENTS } from "@/store/modules/user/consts";
import {
  BANKS_TAB,
  CRYPTO_TAB,
  WALLET_TAB,
  BUY_CRYPTO,
} from "../utils/stringconsts";
import WalletPage from "./WalletPage.vue";
import { enableWalletConnect } from "@/utils/config";
export default {
  components: {
    BTabs,
    BTab,
    ExchangesV2,
    Bank,
    WalletPage,
  },
  props: {
    walletOptions: Array || [],
    convertedCart: Object || {},
    displayCurrency: Object || {},
    isPreview: Boolean || false,
    cartData: Object || {},
    isContinuedTransaction: Boolean || false,
  },
  setup() {
    return { enableWalletConnect } 
  },
  data() {
    return {
      anyWalletCoin: {},
      cryptoWalletName: WALLET_TAB,
      cryptoExchangeName: CRYPTO_TAB,
      bankTabName: BANKS_TAB,
      buyTab: BUY_CRYPTO,
      selectedExchange: null,
      isPaymentMethodVisible: true,
      warningModal: false,
      selectedTabIndex: -1,
      uniqueTabs: [],
      skipRender: false,
      navigateToPreviousStep: false,
      cryptoPaymentStatus: "",
      isSavePayment: true,
      isInProcess: false,
    };
  },
  watch: {
    selectedTab(switchedTab) {
      this.$store.dispatch(`user/${SET_TAB}`, switchedTab);
    },
    filteredTab: {
      handler(paymentTabs) {
        this.uniqueTabs = [...new Set(paymentTabs)];
        const tab = this.loadInitialTab();
        this.selectedTabIndex = this.uniqueTabs.indexOf(tab);

        if (this.selectedTabIndex < 0) {
          this.selectedTabIndex = 0; // ensure that a tab is selected
        }
      },
      deep: true,
    },
    cryptoWalletStep(val) {
      if (val === 2) {
        this.isPaymentMethodVisible = false;
      } else this.isPaymentMethodVisible = true;
    },
  },
  computed: {
    ...mapGetters({
      marketInfo: "user/marketInfo",
      tab: "user/tab",
      cart: "user/cart",
      settings: "user/settings",
      currencies: "user/currencies",
      cryptoWalletStep: "user/getCryptoWalletStep",
    }),
    isFasterPaymentsEnabled() {
      if (this.currencies && this.currencies.length) {
        const filtered = this.currencies.filter(
          (val) => val.fasterConfirmation
        );
        return !!(filtered && filtered.length);
      }
      return false;
    },
    isSubscriptionTabEnabled() {
      if (
        this.convertedCart &&
        this.convertedCart.cart &&
        this.convertedCart.cart.length
      ) {
        const subs = this.convertedCart.cart.some((el) => el.isSubscription);
        return subs;
      }
      return false;
    },
    isGuestUser() {
      if (this.$DbStorage.getItem("isGuestUser")) {
        return JSON.parse(this.$DbStorage.getItem("isGuestUser"));
      }
      return false;
    },
    filteredTab() {
      if (
        this.marketInfo &&
        Object.keys(this.marketInfo).length &&
        Object.keys(this.marketInfo.settings).length &&
        this.marketInfo.settings.tabs.length
      ) {
        return this.marketInfo.settings.tabs;
      }
      return [];
    },
    selectedTab() {
      return this.uniqueTabs[this.selectedTabIndex];
    },
  },
  methods: {
    setInprocess(val) {
      this.isInProcess = val;
    },
    async handleChange(text) {
      this.$store.dispatch(`user/${USER_TRACK_EVENTS}`, {
        moduleInfo: {
          current: text,
          activity: `clicked on ${text} tab`,
        },
      });
    },
    setCryptoPaymentStatus(val) {
      this.cryptoPaymentStatus = val;
    },
    loadInitialTab() {
      if (this.tab) {
        return this.tab;
      }

      if (this.settings && Object.keys(this.settings).length) {
        if (this.settings.method === "crypto") {
          if (
            this.settings.stockId &&
            this.filteredTab.includes(this.cryptoExchangeName)
          ) {
            return this.cryptoExchangeName;
          }
          if (this.filteredTab.includes(this.cryptoWalletName)) {
            return this.cryptoWalletName;
          }
        }
        if (
          this.settings.method === "fiat" &&
          this.filteredTab.includes(this.bankTabName)
        ) {
          return this.bankTabName;
        }
        return this.cryptoWalletName;
      }
      return this.cryptoWalletName;
    },
    getConnectBank() {
      this.$router.push({ name: "AddBank" });
    },
    setLoader(val) {
      this.$emit("handleLoader", val);
    },
    onWalletCoinChange(val) {
      this.anyWalletCoin = val;
    },
    async activateTab(newIndex, oldIndex, event) {
      if (this.skipRender) {
        this.skipRender = false;
        return false;
      }

      if (!this.isPaymentMethodVisible) {
        const walletName =
          this.anyWalletCoin && this.anyWalletCoin.name
            ? this.anyWalletCoin.name
            : "crypto";
        let warnMsg = this.$t("warning-modal.tabs-change");
        warnMsg = warnMsg.replace("[crypto]", ` ${walletName}`);
        event.preventDefault();
        const h = this.$createElement;
        const messageVNode = h("div", { class: ["custom-modal-body"] }, [
          h("div", { class: ["d-flex"] }, [
            h("img", {
              class: ["modal-img mr-2"],
              attrs: { src: require("@/assets/img/bx_info-circle.svg") },
            }),
            h("span", warnMsg),
          ]),
        ]);
        const navigateToNextTab = await this.$bvModal.msgBoxConfirm(
          messageVNode,
          {
            title: this.$t("warning-modal.tabs-change-title"),
            size: "sm",
            buttonSize: "sm",
            cancelTitle: this.$t("warning-modal.proceed"),
            headerClass: "custom-modal-header",
            footerClass: "custom-footer-btns",
            okTitle: this.$t("warning-modal.dismiss"),
          }
        );
        this.$store.dispatch(`user/${USER_TRACK_EVENTS}`, {
          moduleInfo: {
            current: "Crypto Wallet tab",
            activity: "change currency popup opened",
          },
        });
        if (!navigateToNextTab) {
          this.selectedTabIndex = newIndex;
          this.skipRender = true;
          this.isPaymentMethodVisible = true;
          this.navigateToPreviousStep = true;
          this.$store.commit("user/setCryptoWalletStep", 1);
        } else {
          this.selectedTabIndex = oldIndex;
          this.skipRender = false;
        }
      }
      return false;
    },
    // placeOrderOnramp() {
    //   this.setValue({ connect: 'onramp' });
    // },
  },
};
</script>
<style lang="scss">
.payment-options {
  .nav-tabs {
    background-color: $white;
  }

  // margin-bottom: 40px;
  .link-class {
    display: flex !important;
    justify-content: center;
    align-items: center;
    flex-grow: 1;
    padding: 0px !important;
    color: #000000;
    font-size: 10px;
    white-space: nowrap;
    position: relative;
    font-weight: 500;
    height: 34px;
    background-color: #f1f1f1;
    border: 1px solid #dadada !important;
    border-top-left-radius: 15px !important;
    border-top-right-radius: 15px !important;

    &:hover {
      border-bottom: none !important;
    }
  }

  h2 {
    font-size: 15px;
    line-height: 25px;
    color: #000;
    font-weight: 600;
    margin: 0;
    margin-bottom: 8px;
  }

  .payment-option-inner {
    border-radius: 6px;
    background: #ededee;

    .tab-data__wrapper {
      background-color: #fff;

      .tab-data__content {
        border: 1px solid #ededee;
        border-radius: 4px;
        padding: 12px;
        border-top: none;
      }

      // .tab-data__connect-bank {
      //   align-items: center;
      //   justify-content: center;
      //   display: grid;
      //   img {
      //   margin: auto;
      //   max-width: 80px;
      //   }
      //   p {
      //   font-size: 12px;
      //   color: #1E1C41;
      //   text-align: center;
      //   }
      //   &__btn {
      //   width: 60%;
      //   margin: 10px auto;
      //   padding: 2px;
      //   font-size: 14px
      //   }
      // }
    }
  }
}

.active-tab {
  // border-top: 3px solid #5559FE !important;
  color: #fff !important;
  border-collapse: collapse;
  background: #5559fe !important;
  height: 40px;
  border: 1px solid #5559fe !important;

  &_content {
    border-collapse: collapse;
  }
}

.logo {
  width: 25px;
  cursor: pointer;
  animation: bounce 0.5s ease infinite;
}

.logo-i {
  width: 20px;
}

.font-weight-400 {
  font-weight: 500 !important;
  font-size: 12px;
  color: #000000;
}

@keyframes bounce {
  0% {
    transform: translate3d(0px, 0px, 0);
  }

  50% {
    transform: translate3d(0px, -2px, 0);
  }

  100% {
    transform: translate3d(0px, 0px, 0);
  }
}

.my-tooltip-class {
  color: #fff;

  .tooltip-inner {
    max-width: 200px;
    padding: 0.25rem 0.5rem;
    color: #fff !important;
    text-align: left;
    background-color: #000000 !important;
    border-radius: 0.25rem;
    font-family: "Mukta", sans-serif;
    font-size: 11px;
    border: 1px solid #000000 !important;
  }
}

.custom-modal-header {
  padding: 5px 10px !important;
  border-bottom: none !important;

  .modal-title {
    font-size: 14px;
    font-weight: 700;
    padding: 15px;
    margin-bottom: -15px;
  }
}

.custom-modal-body {
  background: rgba(0, 0, 0, 0.05);
  padding: 10px;
  font-size: 13px;
}

.custom-footer-btns {
  .btn {
    padding: 0 10px;
  }

  .btn-secondary {
    cursor: pointer;
    border-radius: 5px;
    color: #303030;
    margin: 0px 5px;
    border: 1px solid #5559fe;
    background: white;
  }
}

.fade-enter-active, .fade-leave-active {
  transition: opacity 0.5s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active in <2.1.8 */ {
  opacity: 0;
}
</style>
